import { Modal } from 'antd'
import React from 'react'
import Forms from '../Forms'

const Model = ({isModalOpen , handleOk , handleCancel}) => {
  return (
    <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        <Forms handleCancel={handleCancel} />
      </Modal>
  )
}

export default Model